import angular from "angular";

import VtSharedModule from '../../../vt-shared/vt-shared.module';
import AdminModuleRouting from './admin-root.module.routing';
import AdminRootComponent from "./admin-root.component";

export default angular
  .module("vt-admin-root.module", [VtSharedModule.name])
  .config(AdminModuleRouting)
  .component("adminPage", AdminRootComponent);
